import styled from 'styled-components';
import { Stack } from '../../components/Stack';
import { Tooltip } from '../../components/Tooltip';
import { theme } from '../../theme';

export const Label = styled.label`
  display: block;
  font-family: ${theme.text.inputLabel.fontFamily};
  font-size: ${theme.text.inputLabel.fontSize};
  font-weight: ${theme.text.inputLabel.fontWeight};
  line-height: ${theme.text.inputLabel.lineHeight};
  color: ${theme.text.inputLabel.color};
`;

export const Hint = styled.span`
  display: block;
  font-family: ${theme.fontFamily};
  font-size: ${theme.sizes[3]};
  line-height: ${theme.sizes[4]};
  color: ${theme.colors.neutral.ink.light};
`;

export const Error = styled.span`
  display: block;
  font-family: ${theme.text.error.fontFamily};
  font-size: ${theme.text.error.fontSize};
  font-weight: ${theme.text.error.fontWeight};
  line-height: ${theme.text.error.lineHeight};
  color: ${theme.text.error.color};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(${theme.sizes[2]} * -1);
    width: 2px;
    background-color: ${theme.colors.secondary.red.base};
  }
`;

export const RootStack = styled(Stack)`
  position: relative;
`;

export const BlockTooltip = styled(Tooltip)`
  /* Tooltip uses inline-block containers which add more height when
     the child component is an inline element (e.g. Glyph or an SVG),
     so we need to set to block to preserve the height and fix alignment. */
  display: block;
  &-hoverable {
    display: flex;
  }
`;
